const initialstate = {
  users: [],
  isLoading: false
}

export default function userReducer(state = initialstate, action) {
  switch (action.type) {
    case 'users/registerSuccess':
      return {
        ...state,
        users: action.payload
      }
    case 'loading/true':
      return {
        ...state,
        isLoading: true
      }
    case 'loading/false':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}

